module.exports = __webpack_public_path__ + "media/images/lane/icon_menu-a359bf95f47d470232bb1d240cf48d70.svg";